<template>
  <v-dialog :value="value" persistent width="800">
    <v-card class="fill">
      <v-toolbar flat dark class="main">
        <v-toolbar-title>Close Billing Period</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('close', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="ma-0 px-4" fluid>
        <v-form ref="form" lazy-validation>
          <v-row class="mt-0 pt-0">
            <v-col>
              <v-autocomplete
                v-model="periodClose.billing_year_id"
                label="Billing Year"
                :items="billingYears"
                background-color="input"
                :menu-props="{ offsetY: true }"
                item-text="name"
                item-value="id"
                :rules="[v => !!v || 'Billing Year is required']"
                outlined
                :disabled="loading"
                @change="getPeriodClose"
                dense>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="periodClose.billing_period_id"
                label="Billing Period"
                :items="billingPeriods"
                background-color="input"
                :menu-props="{ offsetY: true }"
                item-text="name"
                item-value="id"
                :rules="[v => !!v || 'Billing Period is required']"
                outlined
                :disabled="loading"
                @change="getPeriodClose"
                dense>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                v-model="periodClose.period_ad_fees"
                label="Period Ad Fees"
                background-color="input"
                outlined
                dense
                type="number"
                min="0.00"
                step=".01"
                prefix="$"
                :rules="[v => !!v || 'Period Ad Fees is required']"
                hide-details="auto">
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider/>
      <v-card-actions>
      <v-row dense>
        <v-btn 
          class="ma-2"
          color="success"
          @click="submit({ admin: false, retailer: true })" 
          :loading="saving"
          :disabled="saving || !adminPublished">
          Publish Retailer
        </v-btn>
        <v-spacer/>
        <v-btn 
          class="ma-2"
          color="success"
          @click="submit({ admin: true, retailer: false })" 
          :loading="saving"
          :disabled="saving || disableSave">
          Publish Admin
        </v-btn>
      </v-row> 
    </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import PeriodClose from '@/axios/period-close';
// mixins
import { displayAlert } from '@/mixins/displayAlert'
import { validation } from "@/mixins/validation";
import { utils } from '@/mixins/utils'
export default {
  data () {
    return {
      loading: false,
      saving: false,
      periodClosings: [],
      periodClose: {
        period_ad_fees: '',
        billing_year_id: null,
        billing_period_id: null,
      }
    }
  },
  name: 'PeriodCloseModal',
  props: ['value'],
  mixins: [displayAlert, utils, validation],
  async created() {
    const res = await PeriodClose.getList()
    this.periodClosings = res?.data || []
  },
  computed: {
    adminPublished() {
      if (this.periodClose?.pd_close_id) {
        return Boolean(this.periodClose.admin_files_generated_on)
      }
      return false
    },
    retailerPublished() {
      if (this.periodClose?.pd_close_id) {
        return Boolean(this.periodClose.retailer_files_generated_on)
      }
      return false
    },
    disableSave () {
      const { billing_year_id, billing_period_id, period_ad_fees } = this.periodClose
      return !(period_ad_fees && billing_year_id && billing_period_id)
    },
    closedPeriods () {
      return this.periodClosings.filter(p => p && p.published === true)
    },
    billingPeriods () {
      const billingPeriods = this.$store.getters.billingPeriods
      if (billingPeriods?.length > 0 && this.periodClosings.length > 0) {
        return billingPeriods.filter(bp => !this.closedPeriods.some(p => p.this.billing_period_id === bp.id))
      }
      return billingPeriods
    },
    billingYears () {
      const billingYears = this.$store.getters.billingYears
      if (billingYears?.length > 0 && this.periodClosings.length > 0) {
        return billingYears.filter(bp => !this.closedPeriods.some(p => p.this.billing_year_id === bp.id))
      }
      return billingYears
    },
    exists() {
      return Boolean(this.periodClose.pd_close_id)
    }
  },
  methods: {
    async submit (publishArgs = {}) {
      const isValid = this.validate()
      if (!isValid) {
        return
      }
      this.saving = true
      try {
        const { billing_year_id, billing_period_id, period_ad_fees } = this.periodClose
        const payload = {
          billing_year_id, billing_period_id, period_ad_fees
        }
        if (!this.periodClose.pd_close_id) {
          await PeriodClose.add(payload)
        } else {
          await PeriodClose.update(this.periodClose.pd_close_id, payload)
        }
        this.close()
        const submitPayload = {
          billing_year_id, billing_period_id,
          ...publishArgs
        }
        // await PeriodClose.submitPeriodClose(submitPayload) TO DO (does not exist)
        this.emitAlert(true, 'success', `Successfully submitted Period Close`)
        this.$emit('closeProcessModal')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
       }
    },
    validate () {
      return this.$refs.form.validate()
    },
    close () {
      this.$emit('close')
    },
    async getPeriodClose() {
      const { billing_year_id, billing_period_id } = this.periodClose
      if (billing_year_id && billing_period_id) {
        this.loading = true
        try {
          const { data } = await PeriodClose.getByYearPeriod(billing_year_id, billing_period_id)
          if (data?.pd_close_id) {
            this.periodClose.period_ad_fees = data?.period_ad_fees
          }
        } catch (err) {
          this.handleError(err)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
<style>
.v-text-field__slot input::-webkit-calendar-picker-indicator {
  display: none;
}
.v-text-field__slot input[type="date"] {
  cursor: text;
}
.v-text-field__slot input[type="date"]::-webkit-input-placeholder {
  visibility: hidden;
}
</style>